export default __webpack_public_path__ + "static/media/trustedBrandsLogo.fa7098e7.png";